<bolt-header>
    @if (account() && isLoggedIn) {
    <ul slot="utility-links">
        <li>{{account().shortName}}</li>
    </ul>
    }
    <div slot="logo">
        <a href="https://www.nationwide.com/" title="opens in new window" aria-label="Nationwide homepage" target="_blank" rel="noopener noreferrer">
            <bolt-logo type="nw-vertical" target="_blank" rel="nopener noreferrer" class="bolt-header-desktop-only"></bolt-logo>
        </a>
        <a href="https://www.nationwide.com/" title="opens in new window" aria-label="Nationwide homepage" target="_blank" rel="noopener noreferrer">
            <bolt-logo class="bolt-header-mobile-only" type="nw-vertical"></bolt-logo>
        </a>
        <span class="divider"></span>
        <div class="bolt-typography">
            <h4 class="bolt-heading-sm">{{title}}</h4>
        </div>
    </div>
    @if (account() && isLoggedIn) {
    <div id="logout" slot="main-actions">
        <bolt-button (click)="logout()">Log out</bolt-button>
    </div>
    }
    <ul slot="navigation-primary">
        @if (account() && isLoggedIn && isAgreementAccepted) {
        <li>
            <a id="linkPolicyInquiry" href="" [routerLink]="['policy-search']">
                Policy inquiry
            </a>
        </li>
        @if (account().company.propertyAuthorization) {
        <li>
            <a href="" id="linkBulkLien" [routerLink]="['mortgage-bulk-update']">
                Mortgage bulk update
            </a>
        </li>
        }
        @if (account().role.id === admin) {
        <li>
            <a href="" id="linkManageUser" [routerLink]="['/manage-users']">
                Manage user accounts
            </a>
        </li>
        }
        @if (account().role.id === superUser) {
        <li>
            <a id="linkCompany" href="" [routerLink]="['/company-list']">
                Manage company list
            </a>
        </li>
        }
        @if (account().role.id === webSupport) {
        <li>
            <a id="linkWebSupport" href="" [routerLink]="['/web-support']">
                Web support
            </a>
        </li>
        }
        <li>
            <a id="linkChangePassword" (click)="openChangePasswordModal()">
                Change password
            </a>
        </li>
        }
    </ul>
</bolt-header>
<is-modal-wrapper id="changePasswordModal" (primaryButtonClick)="modalClosed()" [isEmpty]="'true'" [useBolt]="'true'" [primaryLabel]="'close'" [openModal]="isChangePasswordModalOpen"
    [modalTitle]="'Change password'" [size]="'small'">
    <div class="self-service-widget-container">
        @if (isChangePasswordModalOpen) {
        <tpi-davinci-widget class="davinci-widget" [type]="'selfService'" [widgetConfig]="widgetConfig"></tpi-davinci-widget>
        }
    </div>
    <!-- is undocumented feature -->
    <div slot="modal-button-bar"></div>
</is-modal-wrapper>